import {
  useState, Dispatch, SetStateAction,
} from 'react';
import { usePathname, useRouter } from 'next/navigation';

import { useQuery } from '@/hooks/useQuery';

interface PaginationResult {
  next: () => void;
  prev: () => void;
  jump: (page: number) => void;
  setCurrentPage: Dispatch<SetStateAction<number>>
  currentPage: number;
  maxPage: number;
}

const usePagination = (itemsPerPage: number, total: number): PaginationResult => {
  const { queryParams } = useQuery();
  const currentQueryPage = Number(queryParams.get('page')?.toString());
  const route = useRouter();
  const path = usePathname();
  const [currentPage, setCurrentPage] = useState<number>(currentQueryPage || 1);
  const maxPage: number = Math.ceil(total / itemsPerPage);

  const next = (): void => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, maxPage));
  };

  const prev = (): void => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const jump = (page: number): void => {
    const pageNumber: number = Math.max(1, page);
    setCurrentPage(() => Math.min(pageNumber, maxPage));

    queryParams.set('page', String(page));
    route.push(`${path}?${queryParams.toString()}`);
  };

  return {
    next, prev, jump, currentPage, maxPage, setCurrentPage,
  };
};

export default usePagination;
